import { Uid } from "./base";

export type UserData = Uid & {
  name: string,
  backgroundImageUrl?: string,
  boardUids: Map<string, Date>, // board uid : last active date
  inviteUids: Map<string, Date>, // board uid : invite request date
};

export const userTransform = (val: any): UserData => {
  // react-firebase-hooks calls transforms with `null` when the snapshot has no data.
  if (val == null) return val as unknown as UserData;
  return <UserData>({
    ...val,
    boardUids: val.boardUids ? new Map(Object.entries(val.boardUids)
      .map(([boardUid, lastActiveEpoch]) => [boardUid, new Date(lastActiveEpoch as number)])
    ) : new Map(),
    inviteUids: val.inviteUids ? new Map(Object.entries(val.inviteUids)
      .map(([boardUid, epoch]) => [boardUid, new Date(epoch as number)])
    ) : new Map(),
  });
};
